import { createRegisterableComponent } from '@news-mono/web-common'
import * as React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Redirect } from 'react-router'
import { NewsletterSignup } from '../banners/NewsletterSignup/NewsletterSignup'
import { RecaptchaProvider } from '../recaptcha/Recaptcha'
import { ThemedRender } from '../__styling'
import { EmailPreference } from './EmailPreference'
import { UnsubscribeAll } from './pages/UnsubscribeAll/UnsubscribeAll'

const queryClient = new QueryClient()

export const EmailPreferenceRegistration = createRegisterableComponent(
    'email-preference',
    (_, services) => {
        if (!services.config.recaptureSiteKey || !services.config.sendgridEnv) {
            return (
                <ThemedRender
                    thewest={() => {
                        return <Redirect to={'/manage-email-preferences'} /> // ssr redirect in app
                    }}
                    perthnow={() => (
                        <NewsletterSignup
                            text="The latest from PerthNow delivered to your inbox daily."
                            buttonLabel="Sign Up"
                            verticalSpacing="md"
                            api={services.config.contentApi}
                            onEvent={services.onEvent}
                            mode="default"
                        />
                    )}
                />
            )
        }

        return (
            <RecaptchaProvider siteKey={services.config.recaptureSiteKey}>
                <QueryClientProvider client={queryClient}>
                    <EmailPreference />
                </QueryClientProvider>
            </RecaptchaProvider>
        )
    },
)

export const EmailPreferenceUnsubscribeAllRegistration =
    createRegisterableComponent(
        'email-preferences-unsubscribe-all',
        (_, services) => {
            if (
                !services.config.recaptureSiteKey ||
                !services.config.sendgridEnv
            ) {
                return (
                    <ThemedRender
                        thewest={() => {
                            return <Redirect to={'/newsletter-redirect'} /> // ssr redirect in app
                        }}
                        perthnow={() => (
                            <NewsletterSignup
                                text="The latest from PerthNow delivered to your inbox daily."
                                buttonLabel="Sign Up"
                                verticalSpacing="md"
                                api={services.config.contentApi}
                                onEvent={services.onEvent}
                                mode="default"
                            />
                        )}
                    />
                )
            }

            return (
                <RecaptchaProvider siteKey={services.config.recaptureSiteKey}>
                    <QueryClientProvider client={queryClient}>
                        <UnsubscribeAll />
                    </QueryClientProvider>
                </RecaptchaProvider>
            )
        },
    )
